/*
	This doesn't do anything besides show a message for validating asset upload name conflicts.

	When uploads begin, they will trigger their own messages with their own components.
*/
import React from "react";
import PropTypes from "prop-types";
import { Icon } from "rhombus-react";

export default function ValidatingAssetsMessage(props){
	let {
		data: {
			libraryName,
			numFiles,
			assetType,
		} = {},
		status,
		timestamp,
		prettyTime,
		iconInfo,
		clearMessage,
	} = props;

	let { icon, title } = iconInfo || {};

	let body;
	if(status === "Failed"){
		body = "There was a problem validating your asset names.  Please try your upload again.";
	} else {
		body = `Validating ${numFiles} ${assetType} asset${(numFiles > 1) ? "s" : ""}`;
	}

	let $clear = <b key="clear" />;
	if(status !== "In Progress"){
		$clear = <Icon key="clear" name="clear" iconStyle="fal" className="clear-message" title="Clear Message" onClick={clearMessage} />;
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${icon}`} title={title} />
		, <div key="body" className="message-body">
			{body}
		</div>

		, $clear
		// Spacer item, because it's display: grid
		, <b key="empty" />

		, <span key="footer" className="message-footer name-overflow" title={libraryName}>{libraryName}</span>
		, <time key="time" className="message-time" dateTime={timestamp}>{prettyTime}</time>
	];
}

ValidatingAssetsMessage.displayName = "ValidatingAssetsMessage";

ValidatingAssetsMessage.propTypes = {
	libraryName: PropTypes.string,
	numFiles: PropTypes.number,
	assetType: PropTypes.oneOf([
		"video",
		"image",
		"richload",
		// "audio",
	]),
	timestamp: PropTypes.number,
	prettyTime: PropTypes.string,
};

ValidatingAssetsMessage.defaultProps = {
	iconInfo: {
		icon: "far sync-alt",
		title: "In Progress...",
	},
};
